import React from 'react';
import moment from 'moment';
// material
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
// entity
import { Message, MessageGroup } from '../../../entities/notification';


interface MessageRowProps {
  messageGroug: MessageGroup;
  message: Message;
}

const MessageRow: React.FC<MessageRowProps> = (props) => {
  const classes = useStyles();

  const getIcon = () => {
    if (props.messageGroug.fromPhoneNumber === props.message.fromPhoneNumber) {
      return <ChatBubbleOutlineIcon fontSize="large" className={classes.icon} />;
    }
    return <ChatBubbleOutlineIcon fontSize="large" className={classes.iconNew} />;
  }

  return (
    <div>
      <Grid container>
        <Grid item xs={1} sm={1} md={2}>
          <div className={classes.iconContainer}>
            {getIcon()}
          </div>
        </Grid>
        <Grid item xs={11} sm={11} md={10}>
          <div className={classes.messageContainer}>
            <div className={classes.header}>
              <div className={classes.date}>{moment(props.message.createdDate).format('MMM Do YYYY hh:mm a')}</div>
              <div className={classes.title}><strong>From:</strong> {props.message.fromPhoneNumber}</div>
            </div>
            <div className={classes.message}>{props.message.message}</div>
          </div>
        </Grid>
      </Grid>
    </div>
  )

}
export default MessageRow;

// #00B878

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      borderBottom: '1px solid #d7dee2'
    },
    title: {
      textAlign: 'left'
    },
    date: {
      fontSize: 10,
      color: '#9db0be',
      textAlign: 'left'
    },
    message: {
      padding: 5,
      textAlign: 'left',
      color: '#5D759D',
      fontSize: 16
    },
    iconContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%'
    },
    messageContainer: {
      paddingLeft: 10
    },
    icon: {
      color: '#627995',
      [theme.breakpoints.down('sm')]: {
        fontSize: 24
      }
    },
    iconNew: {
      color: '#00B878',
      [theme.breakpoints.down('sm')]: {
        fontSize: 24
      }
    }
  })
);


// WEBPACK FOOTER //
// ./src/pages/campaign/components/MessageRow.tsx